<template>
  <router-view/>
</template>

<script>
import { connectUserSocket } from "@/plugins/socket";

export default {
  name: 'App',
  created() {
    if (this.$store.getters.isAuthenticated) {
      const roleStr = this.$store.getters.role;
      const id = this.$store.getters.userId 
      
      let finalRole = roleStr;
      
      if (finalRole === "seller") {
        if (id) {
          connectUserSocket(id, "seller");
        }
      } else {
        if (id) {
          connectUserSocket(id, "user");
        }
      }
    }
  }
};
</script>